import React from "react";
import MagicResearchStepIcon from "./MagicResearchStepIcon";
import { MagicResearchStep, MagicResearchType } from "../../../../lib/types";

interface IProps {
  magicResearch: MagicResearchType;
  govId?: number;
}

const MagicResearch = ({ magicResearch, govId }: IProps) => (
  <div className={"person scrollable"}>
    <ul className="steps" style={{ display: "flex", width: "fit-content" }}>
      {
        Array(10).fill("").map((_, index) => (
          <MagicResearchStepIcon
            govId={govId}
            researchLevel={magicResearch.level}
            step={magicResearch.steps
              .find((step: MagicResearchStep) => step.id === index + 1) || magicResearch.steps[0]}
            nextLevelAvailable={magicResearch.nextLevelAvailable}
          />
        ))
      }
    </ul>
  </div>
)

export default MagicResearch;
